module.exports = __webpack_public_path__ + "img/img3.fed32664.png";